/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCalculationResultDto } from '../models/backend-calculation-result-dto';
import { mlDirectCalculationCreate } from '../fn/ml/ml-direct-calculation-create';
import { mlDirectCalculationCreate$FormData } from '../fn/ml/ml-direct-calculation-create-form-data';
import { MlDirectCalculationCreate$FormData$Params } from '../fn/ml/ml-direct-calculation-create-form-data';
import { MlDirectCalculationCreate$Params } from '../fn/ml/ml-direct-calculation-create';
import { mlDirectCalculationCreate$XWwwFormUrlencoded } from '../fn/ml/ml-direct-calculation-create-x-www-form-urlencoded';
import { MlDirectCalculationCreate$XWwwFormUrlencoded$Params } from '../fn/ml/ml-direct-calculation-create-x-www-form-urlencoded';
import { mlEnumsRetrieve } from '../fn/ml/ml-enums-retrieve';
import { MlEnumsRetrieve$Params } from '../fn/ml/ml-enums-retrieve';
import { mlMlProjectsRetrieve } from '../fn/ml/ml-ml-projects-retrieve';
import { MlMlProjectsRetrieve$Params } from '../fn/ml/ml-ml-projects-retrieve';
import { mlMlProjectsRetrieve2 } from '../fn/ml/ml-ml-projects-retrieve-2';
import { MlMlProjectsRetrieve2$Params } from '../fn/ml/ml-ml-projects-retrieve-2';
import { BackendProjectDataDto } from '../models/backend-project-data-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiMlService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mlDirectCalculationCreate()` */
  static readonly MlDirectCalculationCreatePath = '/api/ml/direct_calculation/';

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlDirectCalculationCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mlDirectCalculationCreate$Response(
    params: MlDirectCalculationCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
    return mlDirectCalculationCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlDirectCalculationCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mlDirectCalculationCreate(
    params: MlDirectCalculationCreate$Params,
    context?: HttpContext,
  ): Observable<BackendCalculationResultDto> {
    return this.mlDirectCalculationCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCalculationResultDto>): BackendCalculationResultDto => r.body),
    );
  }

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlDirectCalculationCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  mlDirectCalculationCreate$XWwwFormUrlencoded$Response(
    params: MlDirectCalculationCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
    return mlDirectCalculationCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlDirectCalculationCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  mlDirectCalculationCreate$XWwwFormUrlencoded(
    params: MlDirectCalculationCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCalculationResultDto> {
    return this.mlDirectCalculationCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCalculationResultDto>): BackendCalculationResultDto => r.body),
    );
  }

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlDirectCalculationCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mlDirectCalculationCreate$FormData$Response(
    params: MlDirectCalculationCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
    return mlDirectCalculationCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Точка для прямых расчетов.
   *
   * Рассчитывает финансовые результаты исходя из данных в body и возвращает их в формате JSON.
   *
   * :param request: Запрос с данными для расчета.
   * :return: JSON с результатами расчета.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlDirectCalculationCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mlDirectCalculationCreate$FormData(
    params: MlDirectCalculationCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCalculationResultDto> {
    return this.mlDirectCalculationCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCalculationResultDto>): BackendCalculationResultDto => r.body),
    );
  }

  /** Path part for operation `mlEnumsRetrieve()` */
  static readonly MlEnumsRetrievePath = '/api/ml/enums/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlEnumsRetrieve$Response(
    params?: MlEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return mlEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlEnumsRetrieve(params?: MlEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.mlEnumsRetrieve$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `mlMlProjectsRetrieve()` */
  static readonly MlMlProjectsRetrievePath = '/api/ml/ml_projects/';

  /**
   * Получение списка всех проектов под мл или определенного проекта по айдишнику.
   *
   * Если в запросе указан параметр 'id', возвращается проект с соответствующим айдишником.
   * В противном случае возвращается список всех проектов под мл.
   *
   * :return: JSON с проектом или списком проектов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlMlProjectsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlMlProjectsRetrieve$Response(
    params?: MlMlProjectsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDataDto>> {
    return mlMlProjectsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение списка всех проектов под мл или определенного проекта по айдишнику.
   *
   * Если в запросе указан параметр 'id', возвращается проект с соответствующим айдишником.
   * В противном случае возвращается список всех проектов под мл.
   *
   * :return: JSON с проектом или списком проектов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlMlProjectsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlMlProjectsRetrieve(params?: MlMlProjectsRetrieve$Params, context?: HttpContext): Observable<BackendProjectDataDto> {
    return this.mlMlProjectsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDataDto>): BackendProjectDataDto => r.body),
    );
  }

  /** Path part for operation `mlMlProjectsRetrieve2()` */
  static readonly MlMlProjectsRetrieve2Path = '/api/ml/ml_projects/{id}/';

  /**
   * Получение списка всех проектов под мл или определенного проекта по айдишнику.
   *
   * Если в запросе указан параметр 'id', возвращается проект с соответствующим айдишником.
   * В противном случае возвращается список всех проектов под мл.
   *
   * :return: JSON с проектом или списком проектов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mlMlProjectsRetrieve2()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlMlProjectsRetrieve2$Response(
    params: MlMlProjectsRetrieve2$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDataDto>> {
    return mlMlProjectsRetrieve2(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение списка всех проектов под мл или определенного проекта по айдишнику.
   *
   * Если в запросе указан параметр 'id', возвращается проект с соответствующим айдишником.
   * В противном случае возвращается список всех проектов под мл.
   *
   * :return: JSON с проектом или списком проектов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mlMlProjectsRetrieve2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mlMlProjectsRetrieve2(
    params: MlMlProjectsRetrieve2$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDataDto> {
    return this.mlMlProjectsRetrieve2$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDataDto>): BackendProjectDataDto => r.body),
    );
  }
}
